import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Image } from "antd";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from "constants/ThemeSetting";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AppConfig from "utils/Config";
import { isNcdcMode } from "utils/Constant";

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { width, themeType } = useSelector(({ settings }) => settings);
  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }
  return (
    <div className="gx-layout-sider-header">
      {navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR ? (
        <div className="gx-linebar">
          <div
            className="gx-icon-btn cursor-pointer"
            onClick={() => {
              setSidebarCollapsed(!sidebarCollapsed);
            }}
          >
            {sidebarCollapsed ? (
              <MenuFoldOutlined
                className={` ${
                  themeType === THEME_TYPE_LITE ? "" : "gx-text-white"
                }`}
              />
            ) : (
              <MenuUnfoldOutlined
                className={` ${
                  themeType === THEME_TYPE_LITE ? "" : "gx-text-white"
                }`}
              />
            )}
          </div>
        </div>
      ) : null}

      <Link to="/" className="gx-site-logo">
        {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ? (
          <Image
            alt={AppConfig.appName}
            src={AppConfig.logoSm}
            width={isNcdcMode ? 90 : 50}
            preview={false}
          />
        ) : themeType === THEME_TYPE_LITE ? (
          <div className="flex items-center" style={{ gap: "0.25rem" }}>
            <Image
              alt={AppConfig.appName}
              src={AppConfig.logoSm}
              width={isNcdcMode ? 90 : 40}
              preview={false}
            />
            <span className="flex flex-nowrap text-lg text-white">
              {AppConfig.appName}
            </span>
          </div>
        ) : (
          <div className="flex items-center gap-x-2">
            <Image
              alt={AppConfig.appName}
              src={AppConfig.logoSm}
              width={isNcdcMode ? 90 : 40}
              preview={false}
            />
            <span className="flex flex-nowrap text-lg text-white">
              {AppConfig.appName}
            </span>
          </div>
        )}
      </Link>
    </div>
  );
};

SidebarLogo.propTypes = {
  sidebarCollapsed: PropTypes.bool,
  setSidebarCollapsed: PropTypes.func,
};
export default SidebarLogo;
